// Amazon-style ProductDetail with responsive Amazon-like layout + Skeleton + Trust Section
import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Paper,
  IconButton,
  Divider,
  Stack,
  Skeleton,
   Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  
} from "@mui/material";
import Chip from '@mui/material/Chip';
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Tooltip from "@mui/material/Tooltip";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ShareIcon from "@mui/icons-material/Share";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import VerifiedIcon from "@mui/icons-material/Verified";
import DiscountIcon from "@mui/icons-material/Discount";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import { setCheckout } from "../utils/buyNowStorage";
import api from "../api/axios";
import { sanitizeHtml } from "../utils/sanitizeHtml";
import ReviewDialog from "../components/reviews/ReviewDialog";
import Checkbox from '@mui/material/Checkbox';
import ProductReviews from "./ProductReviews";
import PolicyBadges from "../pages/vendor/PolicyBadges"
import { getPolicyBadges } from "../utils/policyBadges";

 import BestSellerCarousel from "./BestSellerCarousel";
import {
  CustomersSay,
  ReviewMediaCarousel,
  TopReviews,
} from "../components/reviews/ProductReviewsSection";
import { useRef } from "react";

// import ScrollToTop from "./ScrollToTop";
/* ====================================================== */

  const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
 
  // const product = reelsData.find((item) => String(item.id) === String(id));
  const { toggleWishlist, isWishlisted } = useWishlist();
  // const wishlisted = isWishlisted(product?.id);
  const [liked, setLiked] = useState(false);
  const { addToCart } = useCart();

    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [similarProducts, setSimilarProducts] = useState([]);

    const [pincode, setPincode] = useState("");
    const [qty, setQty] = useState(1);
    const [deliveryEta, setDeliveryEta] = useState("");
    const [openEmi, setOpenEmi] = useState(false);
  // Reviews
const [openReviewDialog, setOpenReviewDialog] = useState(false);
const [editingReviewId, setEditingReviewId] = useState(null);

const [canReview, setCanReview] = useState(false);
const [reviewOrderId, setReviewOrderId] = useState(null);
const [recentlyViewed, setRecentlyViewed] = useState([]);


useEffect(() => {
  window.scrollTo(0, 0);
}, [id]);
  /* ======================
     LOAD PRODUCT (API)
     ====================== */
useEffect(() => {
  const loadProduct = async () => {
    setLoading(true); // 🔥 ADD THIS

    try {
      const res = await api.get(`/reels/${id}`);
      setProduct(res.data);
    } catch (err) {
      console.error("Failed to load product", err);
    } finally {
      setLoading(false);
    }
  };

  loadProduct();
}, [id]);


  /* Recently Viewed ====================== */
  useEffect(() => {
  if (!product?._id) return;

  let viewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];

  // remove duplicates
  viewed = viewed.filter((id) => id !== product._id);

  // add new product at beginning
  viewed.unshift(product._id);

  // keep max 20
  viewed = viewed.slice(0, 20);

  localStorage.setItem("recentlyViewed", JSON.stringify(viewed));
}, [product]);



useEffect(() => {
  const ids = JSON.parse(localStorage.getItem("recentlyViewed")) || [];

  if (!ids.length) return;

  api.post("/products/recently-viewed", { ids })
    .then((res) => setRecentlyViewed(res.data.products))
    .catch(console.error);

}, []);
  
const stock = product?.stock ?? 0;
  const inStock = stock > 0;
  const [activeMedia, setActiveMedia] = useState(null);

useEffect(() => {
  if (qty > stock) {
    setQty(stock > 0 ? 1 : 0);
  }
}, [stock]);
  /* ======================
     MEDIA SETUP
     ====================== */
 const mediaItems = useMemo(() => {
  if (!product) return [];
  const images = Array.isArray(product.images)
    ? product.images.map((img) => ({
        type: "image",
        src: img.thumbnailUrl || img.url, // thumbnail preferred
      }))
    : [];

  const videos = Array.isArray(product.videos)
    ? product.videos.map((vid) => ({
        type: "video",
        src: vid.url,
      }))
    : [];

  return [...images, ...videos];
}, [product]);


  useEffect(() => {
    if (mediaItems.length) {
      setActiveMedia(mediaItems[0]);
    }
  }, [mediaItems]);

  
  useEffect(() => {
  if (!product) return;

  const checkEligibility = async () => {
    try {
      const res = await api.get(`/reviews/eligibility/${product._id}`);
      setCanReview(res.data.canReview);
      setReviewOrderId(res.data.orderId);
    } catch (err) {
      setCanReview(false);
    }
  };

  checkEligibility();
}, [product]);

    /* ======================
     LOAD SIMILAR PRODUCTS (API)
     ====================== */
useEffect(() => {
  if (!product) return;

  const loadSimilar = async () => {
    try {
      const res = await api.get(`/reels/${id}/similar`);
      setSimilarProducts(res.data.similar || []);
    } catch (err) {
      console.error("Failed to load similar products", err);
      setSimilarProducts([]);
    }
  };
  loadSimilar();
}, [product, id]);

useEffect(() => {
  if (location.state?.openReview && canReview) {
    setOpenReviewDialog(true);
  }
}, [location.state, canReview]);

  if (loading) return <ProductDetailSkeleton />;
  if (!product) {
    return <Typography sx={{ p: 4 }}>Product not found</Typography>;
  }

  const wishlisted = isWishlisted(product._id);
  const { title, description, price,videoUrl, imageUrl, vendorName, businessName, policies, vendor } = product;//inStock = true,
  
  // --- DEBUGGING: Check description content ---
  //console.log("Original description:", description);
  //console.log("Sanitized description:", sanitizeHtml(description));
  // ------------------------------------------
  
  const sanitizePrice = (p) => Number(String(p).replace(/,/g, "")) || 0;
const badges = getPolicyBadges(product.policies);
const handleBuyNow = () => {
  console.log("Initiating Buy Now for product:", product);
  const user = JSON.parse(localStorage.getItem("user"));
  setCheckout({
    mode: "BUY_NOW",
    items: [
      {
        id: product._id,
        title: product.title,
        price: sanitizePrice(product.price),
        imageUrl: product.images[0].thumbnailKey,
        qty: qty,
        vendorId:product.vendorId,
        vendorName:product.vendorName,
      },
    ],
  });
  if (!user) return navigate("/login");
  if (!user.profileCompleted) return navigate("/register/customer");
  navigate("/delivery-location");
};

  const handleShare = async () => {
    if (navigator.share) {
      await navigator.share({
        title: product.title,
        text: "Check out this product!",
        url: window.location.href,
      });
    } else {
      alert("Sharing is not supported on this device.");
    }
  };
  /* ====================================================== */
const handleAddToCart = () => {
  if (!product ) return;

  const quantity = qty || 1;
console.log(product, quantity);
  addToCart({
    id: product._id,
    title: product.title,
    price: sanitizePrice(product.price),
    imageUrl: product.images?.[0],
    qty: quantity,
    vendorId: product.vendorId,
    vendorName: product.vendorName,
  });
};

  return (
    <Box sx={{ bgcolor: "#eaeded", minHeight: "100vh", pt: "64px", pb: 4 }}>
      <Grid container sx={{ maxWidth: 1300, mx: "auto", px: 2 }} spacing={3}>
        {/* ================= MEDIA + BUY BOX ================= */}
        <Grid item xs={12}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "2.2fr 1fr" },
              gap: 3,
              alignItems: "flex-start",
            }}
          >
            {/* ================= LEFT: MEDIA + DETAILS ================= */}
            <Card sx={{ borderRadius: 3 }}>
             <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: { xs: "flex-start", md: "stretch" }, // 🔥 key
                flexWrap: "nowrap",
                gap: 2,
              }}
            >

            {/* THUMBNAILS */}
            <Stack
              spacing={1}
              sx={{
                width: 72,          // 🔥 fixed column like Amazon
                flexShrink: 0,
                alignItems: "center",
              }}
            >
              {mediaItems.map((item, i) => (
                <Box
                  key={i}
                  onClick={() => setActiveMedia(item)}
                  sx={{
                    width: 60,
                    height: 60,
                    border:
                      activeMedia?.src === item.src
                        ? "2px solid #ffa41c"
                        : "1px solid #ddd",
                    borderRadius: 1,
                    cursor: "pointer",
                    bgcolor: "#fff",
                  }}
                >
                  {item.type === "image" ? (
                    <img
                      src={item.src}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        bgcolor: "#000",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                      }}
                    >
                      ▶ Video
                    </Box>
                  )}
                </Box>
              ))}
            </Stack>

  {/* MAIN MEDIA */}
  <Box
      sx={{
        flex: 1,
        minWidth: 0,              // 🔥 prevents push-down
        alignSelf: "flex-start",  // 🔥 mobile alignment fix
      }}
    >

    {activeMedia?.type === "video" ? (
      <video controls style={{ width: "100%", height: 420 }}>
        <source src={activeMedia.src} />
      </video>
    ) : (
      <CardMedia
        component="img"
        image={activeMedia?.src}
        sx={{
          width: "100%",
    height: window.innerWidth < 600 ? 300 : 420,
          objectFit: "contain",
          bgcolor: "#fff",
        }}
      />
    )}
  </Box>
</Box>


              <CardContent>
                <Typography variant="h5" fontWeight={700}>
                  {title}
                </Typography>

                <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                  <Box sx={badgeStyle}>
                    <DiscountIcon fontSize="small" /> 10% OFF
                  </Box>
                  <Box sx={badgeStyle}>
                    <LocalShippingIcon fontSize="small" /> Free Delivery
                  </Box>
                  <Box sx={badgeStyle}>
                    <VerifiedIcon fontSize="small" /> Assured
                  </Box>
                </Stack>

                <Divider sx={{ my: 2 }} />

                <Typography variant="h6" color="#B12704" fontWeight={700}>
                  ₹ {Number(price).toLocaleString("en-IN")}
                </Typography>

                {/* <Typography sx={{ mt: 2 }}>{description}</Typography> */}
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mt: 1,
                      "& p": { margin: 0 },
                    }}
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(description),
                    }}
                  />
  {/* <Paper sx={{ p: 1, mt: .5 }}> */}
    {/* {product.policies?.returnPolicy && (
    <Typography>Return: {policies.returnPolicy}</Typography>
  )} */}
  {/* <Stack direction="column" spacing={1}>
  <Chip
  label={policies.returnPolicy}
  title={policies.returnPolicy}
/>
 <Chip
  label={policies.shippingPolicy}
  title={policies.shippingPolicy}
/>
 <Chip
  label={policies.warranty}
  title={policies.warranty}
/>
</Stack> */}
<PolicyBadges badges={badges} />
{/* </Paper> */}
                <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                  <IconButton onClick={() => toggleWishlist(product)}>
                    {wishlisted ? (
                      <FavoriteIcon color="error" />
                    ) : (
                      <FavoriteBorderIcon />
                    )}
                  </IconButton>
                  <IconButton onClick={() => setLiked(!liked)}>
                    {liked ? <ThumbUpIcon /> : <ThumbUpOffAltIcon />}
                  </IconButton>
                  <IconButton>
                    <ShareIcon />
                  </IconButton>
                </Stack>
              </CardContent>
            </Card>

            {/* ================= RIGHT: BUY BOX ================= */}
            <Paper
              sx={{
                p: 3,
                borderRadius: 3,
                position: { md: "sticky" },
                top: 80,
              }}
            >
              <Typography variant="h6" fontWeight={700}>
                ₹ {Number(price).toLocaleString("en-IN")}
              </Typography>

              <Box sx={{ mt: 2 }}>
                <Typography fontWeight={600}>Delivery</Typography>
                <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                  <input
                    value={pincode}
                    maxLength={6}
                    onChange={(e) => setPincode(e.target.value)}
                    placeholder="Enter pincode"
                    style={{ flex: 1, padding: 8 }}
                  />
                  <Button
                    size="small"
                    onClick={() =>
                      pincode.length === 6 &&
                      setDeliveryEta("Delivery by Tomorrow")
                    }
                  >
                    Check
                  </Button>
                </Stack>
                {deliveryEta && (
                  <Typography variant="caption" color="green">
                    {deliveryEta}
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  mt: 2,
                  p: 1,
                  fontWeight: 600,
                  borderRadius: 1,
                  bgcolor: !inStock
                    ? "#fdecea"
                    : stock <= 3
                    ? "#fff4e5"
                    : "#e6f4ea",
                  color: !inStock
                    ? "#b71c1c"
                    : stock <= 3
                    ? "#e65100"
                    : "#1b5e20",
                }}
              >
                {!inStock
                  ? "Currently Unavailable"
                  : stock <= 3
                  ? `Only ${stock} left in stock!`
                  : "In Stock"}
              </Box>
<PolicyBadges badges={badges} />
              <Stack spacing={1.5} sx={{ mt: 2 }}>
                {/* Quantity Selector */}
{/* ================= QUANTITY SELECTOR ================= */}
{inStock && (
  <Box sx={{ mt: 2 }}>
    <Typography fontWeight={600} mb={0.5}>
      Quantity:
    </Typography>

    <select
      value={qty}
      onChange={(e) => setQty(Number(e.target.value))}
      style={{
        width: "100%",
        padding: "8px",
        borderRadius: 4,
        border: "1px solid #ccc",
        background: "#f0f2f2",
        cursor: "pointer",
      }}
    >
      {[...Array(Math.min(stock, 10))].map((_, i) => (
        <option key={i + 1} value={i + 1}>
          {i + 1}
        </option>
      ))}
    </select>

    {stock <= 3 && (
      <Typography
        variant="caption"
        sx={{ display: "block", mt: 1, color: "#e65100" }}
      >
        Only {stock} left in stock!
      </Typography>
    )}
  </Box>
)}
        <Button
          type="button"
          variant="contained"
          disabled={!inStock}
          sx={{
            bgcolor: "#ffd814",
            color: "#000",
            fontWeight: 600,
            opacity: !inStock ? 0.6 : 1,
          }}
          onClick={handleAddToCart}
        >
          Add to Cart
        </Button>
                <Button
                  variant="contained"   disabled={!inStock}
				  sx={{ bgcolor: "#ffa41c", color: "#000", fontWeight: 600,opacity: !inStock ? 0.6 : 1, }}
                  // color="warning"
                  onClick={handleBuyNow}
                >
                  Buy Now
                </Button>
              </Stack>

<Typography variant="caption" sx={{ mt: 2, display: "block" }}>
  Sold by{" "}
  <span
    onClick={() => navigate(`/store/${product.vendorId}`)}
    style={{
      color: "#007185",
      cursor: "pointer",
      fontWeight: 600,
    }}
  >
    {businessName || vendor?.store?.businessName || vendor?.businessName || product?.vendor?.businessName || vendorName}
  </span>
</Typography>
            </Paper>
          </Box>
        </Grid>

        {/* ================= TRUST SECTION ================= */}
        <Grid item xs={12}>
          <Paper sx={{ p: 3, borderRadius: 3 }}>
            <Typography fontWeight={700} mb={1}>
              Why shop with us?
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                🚚 Fast & Free Delivery
              </Grid>
              <Grid item xs={12} sm={6}>
                💳 Secure Payments
              </Grid>
              <Grid item xs={12} sm={6}>
                🔄 Easy Returns
              </Grid>
              <Grid item xs={12} sm={6}>
                ⭐ Top Rated Sellers
              </Grid>
            </Grid>
          </Paper>
            <RatingsReviews
              productId={product._id}
              canReview={canReview}
              onWriteReview={() => setOpenReviewDialog(true)}
              onEditReview={(reviewId) => {
                setEditingReviewId(reviewId);
                setOpenReviewDialog(true);
              }}
            />

          <BankOffers />
          <Typography
                variant="caption"
                sx={{ mt: 1, color: "#007185", cursor: "pointer" }}
                onClick={() => setOpenEmi(true)}
              >
                No-cost EMI available ›
          </Typography>
          <ReviewDialog
            open={openReviewDialog}
            onClose={() => setOpenReviewDialog(false)}
            productId={product._id}
            orderId={reviewOrderId}
          />

              <Dialog open={openEmi} onClose={() => setOpenEmi(false)} fullWidth>
                <DialogTitle>EMI Options</DialogTitle>
                <DialogContent>
                  <Typography>₹499 / month for 12 months</Typography>
                  <Typography>No-cost EMI on select banks</Typography>
                  <Typography>Credit & Debit cards supported</Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenEmi(false)}>Close</Button>
                </DialogActions>
              </Dialog>
        <FrequentlyBoughtTogether product={product} />
        <SpecsTable product={product} />
        <SimilarProducts products={similarProducts} navigate={navigate} />
        <BestSellerCarousel
          categoryId={product.category}
          navigate={navigate}
        />
        {/* <RecentlyViewed products={reelsData} navigate={navigate} /> */}
        <RecentlyViewed
          products={recentlyViewed}
          navigate={navigate}
        />
        </Grid>        
      </Grid>
    </Box>
  );
};

/* ====================== SKELETON ====================== */

const ProductDetailSkeleton = () => (
  <Box sx={{ bgcolor: "#eaeded", minHeight: "100vh", pt: "64px", pb: 4 }}>
    <Grid container sx={{ maxWidth: 1300, mx: "auto", px: 2 }} spacing={3}>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "2.2fr 1fr" },
            gap: 3,
            alignItems: "flex-start",
          }}
        >
          {/* ================= LEFT: MEDIA SKELETON ================= */}
          <Card sx={{ borderRadius: 3, p: 2 }}>
            <Grid container spacing={2}>
              {/* Thumbnails skeleton */}
              <Grid item xs={2}>
                <Stack spacing={1}>
                  {[...Array(4)].map((_, i) => (
                    <Skeleton
                      key={i}
                      variant="rectangular"
                      height={60}
                      sx={{ borderRadius: 1 }}
                    />
                  ))}
                </Stack>
              </Grid>

              {/* Main image skeleton */}
              <Grid item xs={10}>
                <Skeleton
                  variant="rectangular"
                  height={420}
                  sx={{ borderRadius: 2 }}
                />
              </Grid>
            </Grid>

            <Box sx={{ mt: 2 }}>
              <Skeleton height={32} width="80%" />
              <Skeleton height={20} width="60%" sx={{ mt: 1 }} />
              <Skeleton height={20} width="90%" sx={{ mt: 1 }} />
            </Box>
          </Card>

          {/* ================= RIGHT: BUY BOX SKELETON ================= */}
          <Paper sx={{ p: 3, borderRadius: 3 }}>
            <Skeleton height={32} width="60%" />
            <Skeleton height={20} width="40%" sx={{ mt: 1 }} />

            <Skeleton
              variant="rectangular"
              height={40}
              sx={{ mt: 2, borderRadius: 1 }}
            />
            <Skeleton
              variant="rectangular"
              height={40}
              sx={{ mt: 2, borderRadius: 1 }}
            />

            <Skeleton height={20} width="80%" sx={{ mt: 2 }} />
          </Paper>
        </Box>
      </Grid>
    </Grid>
  </Box>
);
/* ====================================================== */
// ================= RATINGS & REVIEWS =================
const RatingsReviews = ({
  productId,
  canReview,
  onWriteReview,
  onEditReview,
}) => {
  const [summary, setSummary] = useState(null);
  const [myReviewId, setMyReviewId] = useState(null);
  const [highlight, setHighlight] = useState(false);
 const reviewsRef = useRef(null);
 const location = useLocation();

 const handleGoToReviews = () => {
  reviewsRef.current?.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
};
useEffect(() => {
  if (location.hash === "#reviews") {
    setTimeout(() => {
      reviewsRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 300);
  }
}, [location]);
  /* Load rating summary */
  useEffect(() => {
    api
      .get(`/reviews/summary/${productId}`)
      .then((res) => setSummary(res.data))
      .catch(() => setSummary(null));
  }, [productId]);

  /* Check if user already reviewed */
  useEffect(() => {
    if (!canReview) return;

    api
      .get(`/reviews/my/${productId}`)
      .then((res) => setMyReviewId(res.data.reviewId))
      .catch(() => setMyReviewId(null));
  }, [productId, canReview]);

  if (!summary) return null;

  return (
   <Box
  ref={reviewsRef}
  sx={{
    transition: "0.3s",
    bgcolor: highlight ? "#fff9c4" : "transparent"
  }}
>
    <Paper sx={{ mt: 3, p: 3, borderRadius: 3 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography fontWeight={700}>
          Customer Reviews
        </Typography>

        {canReview && (
          <Button
            size="small"
            variant="outlined"
            sx={{ textTransform: "none", fontWeight: 600 }}
            onClick={() =>
              myReviewId
                ? onEditReview(myReviewId)
                : onWriteReview()
            }
          >
            {myReviewId ? "Edit your review" : "Write a review"}
          </Button>
        )}
      </Box>

      {/* Average */}
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography fontSize={32} fontWeight={700}>
          {summary.average.toFixed(1)}
        </Typography>
        <Typography fontSize={20}>⭐</Typography>
      </Stack>

{/* RATINGS SUMMARY */}
<Typography
  variant="body2"
  color="primary"
  sx={{ cursor: "pointer", textDecoration: "underline" }}
 onClick={() => {
    reviewsRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  }}
>
   Based on {(summary.total || 0).toLocaleString()} ratings
</Typography>
      {/* Distribution */}
      <Stack spacing={0.8} sx={{ mt: 2 }}>
        {[5, 4, 3, 2, 1].map((star) => {
          const percent = summary.distribution[star] || 0;
          return (
            <Stack
              key={star}
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <Typography variant="caption" sx={{ width: 42 }}>
                {star} ★
              </Typography>

              <Box
                sx={{
                  flex: 1,
                  height: 8,
                  bgcolor: "#eee",
                  borderRadius: 1,
                }}
              >
                <Box
                  sx={{
                    width: `${percent}%`,
                    height: "100%",
                    bgcolor: "#ffa41c",
                  }}
                />
              </Box>

              <Typography variant="caption" sx={{ width: 36 }}>
                {percent}%
              </Typography>
            </Stack>
          );
        })}
      </Stack>
{/* CATEGORY RATINGS */}
{/* <Box sx={{ mt: 3 }}>
  <Typography fontWeight={600} sx={{ mb: 1 }}>
    Rating Breakdown
  </Typography>

  {[
    { key: "productQuality", label: "Product Quality" },
    { key: "valueForMoney", label: "Value for Money" },
    { key: "deliveryExperience", label: "Delivery Experience" },
    { key: "sellerService", label: "Seller Service" },
    { key: "agentExperience", label: "Agent Experience" },
  ].map((item) => (
    <Stack
      key={item.key}
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{ mb: 1 }}
    >
      <Typography sx={{ width: 150, fontSize: 13 }}>
        {item.label}
      </Typography>

      <Box
        sx={{
          flex: 1,
          height: 8,
          bgcolor: "#eee",
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            width: `${(summary.categories?.[item.key] || 0) * 20}%`,
            height: "100%",
            bgcolor: "#ffa41c",
          }}
        />
      </Box>

      <Typography sx={{ width: 40, fontSize: 12 }}>
        {summary.categories?.[item.key]?.toFixed(1) || "0.0"}
      </Typography>
    </Stack>
  ))}
</Box> */}
      <Divider sx={{ my: 2 }} />

      <Typography variant="caption" color="text.secondary">
        Only verified purchases can leave reviews
      </Typography>
      {/* FULL REVIEWS SECTION */}
<Box ref={reviewsRef} >
  <ProductReviews productId={productId} />
</Box>
    </Paper>
    </Box>
  );
};



// Product Specifications (Amazon-style table from variants)
const SpecsTable = ({ product }) => {
  const variants = Array.isArray(product.variants)
    ? product.variants.filter(v => v?.attributes)
    : [];

  // 1️⃣ Build attribute map from variants
  const variantSpecs = {};

  variants.forEach((v) => {
    Object.entries(v.attributes || {}).forEach(([key, value]) => {
      if (!variantSpecs[key]) {
        variantSpecs[key] = new Set();
      }
      variantSpecs[key].add(String(value));
    });
  });

  // 2️⃣ Convert Sets → strings
  const derivedSpecs = Object.fromEntries(
    Object.entries(variantSpecs).map(([k, v]) => [
      k,
      Array.from(v).join(", "),
    ])
  );

  // 3️⃣ Static + derived specs (Amazon style)
  const specs = {
    Brand: product.brand || "Generic",
    ...derivedSpecs,
    // Country: product.country || "India",
    // Warranty: product.warranty || "No warranty",
  };

  return (
    <Paper sx={{ mt: 3, p: 3, borderRadius: 3 }}>
      <Typography fontWeight={700} mb={2}>
        Product Specifications
      </Typography>

      <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
        {Object.entries(specs).map(([key, value], index) => (
          <Box
            key={key}
            sx={{
              display: "flex",
              bgcolor: index % 2 === 0 ? "#fafafa" : "#fff",
              borderBottom:
                index !== Object.keys(specs).length - 1
                  ? "1px solid #e0e0e0"
                  : "none",
            }}
          >
            <Box sx={{ width: "35%", p: 1.5, fontWeight: 600 }}>
              {key}
            </Box>
            <Box sx={{ width: "65%", p: 1.5, color: "#555" }}>
              {value || "—"}
            </Box>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};


// Bank Offers Block
const BankOffers = () => (
  <Paper sx={{ mt: 3, p: 3, borderRadius: 3 }}>
    <Typography fontWeight={700} mb={1}>Offers & EMI</Typography>
    <Typography>💳 No-cost EMI from ₹499/month</Typography>
    <Typography>🏦 10% Instant Bank Discount</Typography>
    <Typography>🎁 Extra cashback on Wallets</Typography>
  </Paper>
);

const getPrimaryImage = (imageUrl) => {
  if (Array.isArray(imageUrl) && imageUrl.length > 0) {
    return imageUrl[0];
  }
  if (typeof imageUrl === "string") {
    return imageUrl;
  }
  return "/images/placeholder.png"; // fallback
};

const getPrimaryMediaUrl = (product) => {
  // ✅ For Similar Products API
  if (product?.imageUrl) {
    return product.imageUrl;
  }

  // ✅ For Full Product API
  if (product?.images?.length > 0 && product.images[0]?.url) {
    return product.images[0].thumbnailUrl;
  }

  if (product?.videos?.length > 0 && product.videos[0]?.thumbnailUrl) {
    return product.videos[0].thumbnailUrl;
  }

  return "/placeholder-product.png";
};

// Frequently Bought Together
const FrequentlyBoughtTogether = ({ product }) => {
  const navigate = useNavigate();

  const [items, setItems] = React.useState([]);
  const [selected, setSelected] = React.useState({});
  const [quantities, setQuantities] = React.useState({});

  React.useEffect(() => {
    if (!product?._id) return;

    api
      .get(`/products/${product._id}/frequently-bought-together`)
      .then((res) => {
        const list = [product, ...(res.data.products || [])];
        setItems(list);

        const initial = {};
        list.forEach((p) => (initial[p._id] = true));
        setSelected(initial);
      });
  }, [product]);

  const toggle = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const selectedItems = items.filter((p) => selected[p._id]);

  const totalPrice = selectedItems.reduce(
    (sum, p) => sum + Number(p.price || 0),
    0
  );

  if (!items.length) return null;

  return (
    <Paper
      sx={{
        mt: 5,
        p: { xs: 2, md: 3 },
        borderRadius: 2,
        border: "1px solid #e0e0e0",
      }}
    >
      <Typography fontWeight={700} fontSize={18} mb={3}>
        Frequently Bought Together
      </Typography>

      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={4}
        alignItems="stretch"
      >
        {/* PRODUCTS (Horizontal Scroll on Mobile) */}
        <Box
  sx={{
    display: "flex",
    alignItems: "center",
    // justifyContent: "space-between",
    flexWrap: "nowrap",
    gap: 1,
  }}
>
  {items.map((item, index) => (
    <React.Fragment key={item._id}>
      {index > 0 && (
        <Typography sx={{ fontSize: 20, color: "#bbb" }}>
          +
        </Typography>
      )}

      <Box
        sx={{
          width: { xs: 70, sm: 120 },
          textAlign: "center",
        }}
      >
        <Checkbox
          size="small"
          checked={!!selected[item._id]}
          onChange={() => toggle(item._id)}
          sx={{ p: 0 }}
        />

        <Box
          sx={{
            height: { xs: 60, sm: 100 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid #eee",
            borderRadius: 1,
            cursor: "pointer",
          }}
          onClick={() => navigate(`/product/${item._id}`)}
        >
          <img
            src={item.imageUrl || getPrimaryMediaUrl(item)}
            alt={item.title}
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </Box>

        <Typography
          sx={{
            fontSize: 11,
            mt: 0.5,
            height: 30,
            overflow: "hidden",
          }}
        >
          {item.title}
        </Typography>

        <Typography
          sx={{
            fontWeight: 600,
            fontSize: 12,
            color: "#B12704",
          }}
        >
          ₹{Number(item.price || 0).toLocaleString("en-IN")}
        </Typography>
      </Box>
    </React.Fragment>
  ))}
</Box>

        {/* TOTAL SECTION */}
        <Box
          sx={{
            minWidth: { xs: "100%", md: 240 },
            borderLeft: { xs: "none", md: "1px solid #eee" },
            borderTop: { xs: "1px solid #eee", md: "none" },
            pl: { xs: 0, md: 3 },
            pt: { xs: 2, md: 0 },
          }}
        >
          <Typography fontSize={14} mb={0.5}>
            Total price:
          </Typography>

          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: "#B12704",
              mb: 0.5,
            }}
          >
          ₹{Number(totalPrice || 0).toLocaleString("en-IN")}
          </Typography>

          <Typography fontSize={13} color="#555" mb={2}>
            for {selectedItems.length} item
            {selectedItems.length > 1 ? "s" : ""}
          </Typography>

          <Button
            fullWidth
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 1,
              backgroundColor: "#FFD814",
              color: "#111",
              "&:hover": {
                backgroundColor: "#F7CA00",
              },
            }}
            onClick={() => {
              const selectedItems = items.filter(
                (p) => selected[p._id]
              );

              console.log("Add to cart:", selectedItems);
            }}
          >
            Add {selectedItems.length} item
            {selectedItems.length > 1 ? "s" : ""} to Cart
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};

// Similar Products Carousel (simple horizontal)
const SimilarProducts = ({ products, navigate }) => {
  if (!products?.length) return null;

  return (
    <Paper
      sx={{
        mt: 5,
        p: 3,
        borderRadius: 2,
        border: "1px solid #e0e0e0",
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: 18,
          mb: 3,
        }}
      >
        Similar Products
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 3,
          overflowX: "auto",
          pb: 1,
          "&::-webkit-scrollbar": { height: 6 },
          "&::-webkit-scrollbar-thumb": {
            background: "#ddd",
            borderRadius: 4,
          },
        }}
      >
        {products.slice(0, 10).map((p) => (
          <Box
            key={p._id}
            sx={{
              minWidth: 180,
              maxWidth: 180,
              flexShrink: 0,
              cursor: "pointer",
              transition: "0.2s",
              "&:hover .title": {
                color: "#C7511F",
                textDecoration: "underline",
              },
            }}
            onClick={() => navigate(`/product/${p._id}`)}
          >
            {/* IMAGE BOX */}
            <Box
              sx={{
                height: 160,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1.5,
              }}
            >
              <img
                src={getPrimaryMediaUrl(p)}
                alt={p.title}
                loading="lazy"
                style={{
                  maxHeight: 150,
                  maxWidth: 150,
                  objectFit: "contain",
                }}
              />
            </Box>

            {/* TITLE */}
            <Tooltip title={p.title} arrow>
              <Typography
                className="title"
                sx={{
                  fontSize: 14,
                  lineHeight: "20px",
                  height: "40px",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  textOverflow: "ellipsis",
                  color: "#007185",
                  mb: 0.5,
                }}
              >
                {p.title}
              </Typography>
            </Tooltip>

            {/* PRICE */}
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 700,
                color: "#111",
              }}
            >
              ₹{Number(p.price || 0).toLocaleString("en-IN")}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

// Recently Viewed
const RecentlyViewed = ({ products = [], navigate }) => (
  <Paper sx={{ mt: 3, p: 3, borderRadius: 3 }}>
    <Typography fontWeight={700} mb={2}>
      Recently Viewed
    </Typography>

    <Stack direction="row" spacing={2} sx={{ overflowX: "auto" }}>
      {products.slice(0, 6).map((p) => (
        <Box
          key={p._id}
          sx={{
            width: 160,
            cursor: "pointer",
            flexShrink: 0,
          }}
          onClick={() => navigate(`/product/${p._id}`)}
        >
          <Box
                  sx={{
                    width: { xs: 70, sm: 120 },
                    textAlign: "center",
                  }}
          >
            <img
              src={p.images[0].thumbnailUrl || getPrimaryMediaUrl(p)}
              alt={p.title}
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box>

          <Typography
            variant="body2"
            sx={{
              mt: 1,
              fontWeight: 500,
              lineHeight: 1.2,
              height: 34,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {p.title}
          </Typography>

          <Typography
            sx={{
              fontWeight: 700,
              color: "#B12704", // Amazon price color
              fontSize: 14,
            }}
          >
            ₹{Number(p.price || 0).toLocaleString("en-IN")}
          </Typography>
        </Box>
      ))}
    </Stack>
  </Paper>
);

const badgeStyle = {
  display: "flex",
  alignItems: "center",
  gap: 0.5,
  px: 1,
  py: 0.5,
  bgcolor: "#f0f2f2",
  borderRadius: 1,
  fontSize: 12,
  fontWeight: 600,
};

export default ProductDetail;